import { inject } from '@angular/core'
import { Router, type CanActivateFn } from '@angular/router'
import { ProfileApiService } from '@api/profile-api.service'
import { TCurrentUserResponse } from '@app/types/TCurrentUser'
import { ToastrService } from 'ngx-toastr'
import { CurrentUserService } from './services/current-user.service'
import { map, take, tap } from 'rxjs'

export const authGuard: CanActivateFn = (route, state) => {
    const router = inject(Router)
    const toastrService = inject(ToastrService)
    const profileApiService = inject(ProfileApiService)
    const currentUserService = inject(CurrentUserService)

    const token = localStorage.getItem('jwt')
    const userId = localStorage.getItem('id')

    const currentUser: Partial<TCurrentUserResponse> | undefined =
        currentUserService.getCurrentUser() || undefined

    if (!token || !userId) {
        toastrService.error('Вы не авторизованы')
        router.navigate(['/auth'])
        return false
    }

    if (!currentUser?.userId) {
        return profileApiService.getCurrentUser().pipe(
            take(1),
            map((res) => {
                if (res?.data?.userId === userId) {
                    currentUserService.setCurrentUser(res.data)
                    return true
                }

                return false
            }),
            tap({
                error: () => {
                    router.navigate(['auth'])
                    toastrService.error('Вы не авторизованы')
                },
            })
        )
    }

    return currentUser.userId === userId
}
